import transferWrapper from '../components/wrapper';
import React, { FC, useState } from 'react';
import { Button, InputWraper, useForm } from 'modules';
import { InputFile, ModalPinCode } from '../../../components';
import * as Yup from 'yup';
import { Icon } from '../../../components';
import TableElectricBillList from '../components/tableElectricBillList';

const ElectricBillUploadFile: FC = transferWrapper(() => {
  const [isShowPopup, setIsShowPopup] = useState<boolean>(true);

  const { getInputProps, handleSubmit, isSubmitting } = useForm({
    structure: [
      {
        name: 'electricBillFile',
        validate: Yup.string().required('Must be provided'),
      },
    ],
    onSubmit: async (values: any) => {
      console.log(values);
    },
  });
  return (
    <div className='electric-bill-upload-file'>
      <div className='electric-bill-upload-file__input'>
        <InputWraper
          className='electric-bill-upload-file__input__file'
          label={'Tải tệp đơn hàng lên'}
          inputProps={getInputProps('electricBillFile')}
          renderInput={(props) => <InputFile {...props} />}
        />
        <Icon.Upload />
      </div>

      <div className='electric-bill-upload-file__action'>
        <Button
          className='electric-bill-upload-file__action__query'
          label={'Truy vấn'}
          type='submit'
          buttonType='success'
          // isLoading={isSubmitting}
          onClick={handleSubmit}
        />

        <Button
          className='electric-bill-upload-file__action__download'
          label={'Tải về biểu mẫu'}
          type='submit'
          buttonType='info'
          // isLoading={isSubmitting}
          onClick={handleSubmit}
        />
      </div>

      <TableElectricBillList />

      <ModalPinCode
        isOpen={isShowPopup}
        onClose={() => setIsShowPopup(false)}
        onConfirm={async () => setIsShowPopup(false)}
      />
    </div>
  );
});

export default ElectricBillUploadFile;
